import { StyledFormTitle } from '@elements/Title';

export function SeasonalityNoData() {
  return (
    <div className="sk:flex! sk:items-center! sk:justify-center! sk:pt-5!">
      <StyledFormTitle>No Sales Forecast Data</StyledFormTitle>
    </div>
  );
}

export default SeasonalityNoData;
